import React, { useContext } from "react"
import { Link, navigate } from "gatsby"
import { LanguageContext } from "../context"
import { homePagePaths, translate } from "../translate"
import Logo from "./unida-logo"
import TopMenu from "./top-menu"
import VisitUs from "./button-visit-us"

const Navbar = (props) => {
  return (
    <nav
      className="navbar navbar-expand-lg navbar-light bg-light top-navbar fixed-top"
    >
      <Logo link="/" lang={props?.lang} />
      <TopMenu lang={props?.lang} location={props?.location} /> 
      <VisitUs lang={props?.lang} />
    </nav>
  )
}

export default Navbar
